<button rel="button" aria-label="Select locale" class="hidden md:flex h-full w-8 cursor-pointer content-center" id="locale-picker" (click)="openDialog()">
    <advanced-image
        [cldImg]="img"
        alt="Select a language"
        [plugins]="plugins"
        class="w-full"
        height="32px"
    >
    </advanced-image>
</button>
<div class="block md:hidden">
    <button rel="button" aria-label="Select locale"  class="flex items-center text-base font-bold leading-7 hover:underline underline-offset-8" (click)="openDialog()">
        <advanced-image
            [cldImg]="img"
            alt="Select a language"
            [plugins]="plugins"
            class="w-4 h-4 mr-1.5 inline-block"
        ></advanced-image>
        <span class="inline-block" i18n>Select a region</span>
    </button>
</div>
